
const messages = {
    en: {
       afip: {
          factura: {
            name: 'Factura',
            title: 'Factura management',
            subtitle: 'View, search, create, edit and delete Factura',
            creating: 'Creating Factura',
            editing: 'Editing Factura',
            deleting: 'Deleting Factura',
            showing: 'Showing Factura',
            menu: 'Factura',
            labels: {
                CantReg: 'CantReg',
                PtoVta: 'Punto de venta',
                CbteTipo: 'Tipo de comprobante',
                Concepto: 'Concepto',
                DocTipo: 'Tipo de documento',
                DocNro: 'Número de documento',
                CbteDesde: 'CbteDesde',
                CbteHasta: 'CbteHasta',
                CbteFch: 'CbteFch',
                ImpTotal: 'ImpTotal',
                ImpTotConc: 'ImpTotConc',
                ImpNeto: 'ImpNeto',
                ImpOpEx: 'ImpOpEx',
                ImpIVA: 'ImpIVA',
                ImpTrib: 'ImpTrib',
                MonId: 'MonId',
                MonCotiz: 'MonCotiz',
                CAE: 'CAE',
                CAEFchVto: 'CAEFchVto',
                VoucherNumber: 'Numero Comprobante',
                Error: 'Error',
                Estado: 'Estado',
                facturar: "Facturar",
                Importe: 'Importe',
                CuitEmisor: 'Cuit Emisor',
                FchServDesde: 'Fecha servicio desde',
                FchServHasta: 'Fecha servicio hasta',
                FchVtoPago: 'Fecha servicio vencimiento',
                CondicionIVAReceptor: 'Condicion IVA Receptor',
                RazonSocialReceptor: 'Razón Social Receptor',
                DomicilioReceptor: 'Domicilio Receptor',
                CondicionVenta: 'Condición Venta',
                ProductoServicio: 'Producto/Servicio',
                Alicuota: 'Alicuota'
            },

          }
       }
    },
    es: {
       afip: {
          factura: {
            name: 'Factura',
            title: 'Administración de Factura',
            subtitle: 'Ver, buscar, crear, editar, y borrar Factura',
            creating: 'Creando Factura',
            editing: 'Modificando Factura',
            deleting: 'Eliminando Factura',
            showing: 'Detalles de Factura',
            menu: 'Factura',
            labels: {
                CantReg: 'Cantidad de comprobantes a registrar',
                PtoVta: 'Punto de venta',
                CbteTipo: 'Tipo de comprobante',
                Concepto: 'Concepto',
                DocTipo: 'Tipo de documento',
                DocNro: 'Número de documento del comprador',
                CbteDesde: 'Número de comprobante desde',
                CbteHasta: 'Número de comprobante  hasta',
                CbteFch: 'Fecha',
                ImpTotal: 'Importe total del comprobante',
                ImpTotConc: 'Importe neto no gravado',
                ImpNeto: 'Importe neto gravado',
                ImpOpEx: 'Importe exento de IVA',
                ImpIVA: 'Importe total de IVA',
                ImpTrib: 'Importe total de tributos',
                MonId: 'Tipo de moneda',
                MonCotiz: 'Cotización de la moneda',
                CAE: 'CAE',
                CAEFchVto: 'CAEFchVto',
                VoucherNumber: 'Numero Comprobante',
                Error: 'Error',
                Estado: 'Estado',
                facturar: "Facturar",
                Importe: 'Importe',
                CuitEmisor: 'Cuit Emisor',
                FchServDesde: 'Fecha servicio desde',
                FchServHasta: 'Fecha servicio hasta',
                FchVtoPago: 'Fecha servicio vencimiento',
                CondicionIVAReceptor: 'Condicion IVA Receptor',
                RazonSocialReceptor: 'Razón Social Receptor',
                DomicilioReceptor: 'Domicilio Receptor',
                CondicionVenta: 'Condición Venta',
                ProductoServicio: 'Producto/Servicio',
                Alicuota: 'Alicuota'
            },

          }
       }
    },
    pt: {
       afip: {
          factura: {
            name: 'Factura',
            title: 'Administração de Factura',
            subtitle: 'Ver, buscar, criar, editar e usar Factura',
            creating: 'Criando Factura',
            editing: 'Edição Factura',
            deleting: 'Apagando Factura',
            showing: 'Detalhes do Factura',
            menu: 'Factura',
            labels: {
                CantReg: 'CantReg',
                PtoVta: 'Punto de venta',
                CbteTipo: 'Tipo de comprobante',
                Concepto: 'Concepto',
                DocTipo: 'Tipo de documento',
                DocNro: 'Número de documento',
                CbteDesde: 'CbteDesde',
                CbteHasta: 'CbteHasta',
                CbteFch: 'CbteFch',
                ImpTotal: 'ImpTotal',
                ImpTotConc: 'ImpTotConc',
                ImpNeto: 'ImpNeto',
                ImpOpEx: 'ImpOpEx',
                ImpIVA: 'ImpIVA',
                ImpTrib: 'ImpTrib',
                MonId: 'MonId',
                MonCotiz: 'MonCotiz',
                CAE: 'CAE',
                CAEFchVto: 'CAEFchVto',
                VoucherNumber: 'Numero Comprobante',
                Error: 'Error',
                Estado: 'Estado',
                facturar: "Facturar",
                Importe: 'Importe',
                CuitEmisor: 'Cuit Emisor',
                FchServDesde: 'Fecha servicio desde',
                FchServHasta: 'Fecha servicio hasta',
                FchVtoPago: 'Fecha servicio vencimiento',
                CondicionIVAReceptor: 'Condicion IVA Receptor',
                RazonSocialReceptor: 'Razón Social Receptor',
                DomicilioReceptor: 'Domicilio Receptor',
                CondicionVenta: 'Condición Venta',
                ProductoServicio: 'Producto/Servicio',
                Alicuota: 'Alicuota'
            },

          }
       }
    }
}

export default messages
